import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  MobileStepper,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import Link from '../controls/Link'
import TutorialStep1 from './TutorialStep1'
import TutorialStep2 from './TutorialStep2'
import TutorialStep3 from './TutorialStep3'

import { removeState } from '../../utils/LocalStorage'

import SmallArrowLeft from '../../../assets/images/icons/ico_arrow_left_small.svg'
import SmallArrowRight from '../../../assets/images/icons/ico_arrow_small.svg'

import { SHOW_DASHBOARD_INTRO } from '../../constants'

const tutorialSteps = [
  <TutorialStep1 />,
  <TutorialStep2 />,
  <TutorialStep3 />,
]

const STEPS = tutorialSteps.length

class Intro extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    root: {
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        paddingBottom: '150px',
      },
      [theme.breakpoints.up('md')]: {
        paddingBottom: 'inherit',
      },
    },
    tutorialContainer: {
      width: 'fit-content',
      [theme.breakpoints.down('sm')]: {
        margin: '40px auto 0 auto',
      },
      [theme.breakpoints.up('md')]: {
        margin: '0 auto',
      },
    },
    stepperContainer: {
      width: '100%',
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        height: '150px',
        position: 'fixed',
        bottom: 0,
        left: 0,
        boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.15)',
        background: '#FFD850',
      },
    },
    stepCount: {
      position: 'relative',
      top: '-20px',
      display: 'inline-block',
      minWidth: '65px',
      background: '#000',
      color: '#fff',
      textAlign: 'center',
      boxSizing: 'border-box',
      padding: '8px',
    },
    mobileStepperRoot: {
      background: 'transparent',
      width: '100%',
      padding: 0,
      margin: '0 auto',
      maxWidth: '1050px',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '300px',
      },
    },
    dot: {
      borderRadius: 0,
      width: '30px',
      height: '3px',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      [theme.breakpoints.up('md')]: {
        width: '80px',
      },
    },
    dotActive: {
      backgroundColor: '#fff',
    },
    buttonContained: {
      ...theme.buttonContained,
      [theme.breakpoints.down('sm')]: {
        width: '85px',
        '& svg, & img': {
          margin: '0 !important',
        },
      },
      [theme.breakpoints.up('md')]: {
        width: '115px',
      },
    },
    buttonLabel: {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    leftIcon: {
      '& svg, & img': {
        marginLeft: 0,
        marginRight: '16px',
      },
    },
    link: theme.introLink,
  })

  state = {
    activeStep: 0,
  }

  componentDidMount() {
    removeState(SHOW_DASHBOARD_INTRO)
  }

  handleNext = () => {
    this.setState((prevState) => ({
      activeStep: prevState.activeStep + 1,
    }))
  }

  handleBack = () => {
    this.setState((prevState) => ({
      activeStep: prevState.activeStep - 1,
    }))
  }

  renderNextButton = () => {
    const { classes } = this.props

    if (this.state.activeStep === STEPS - 1) {
      return (
        <Button
          variant="contained"
          classes={{ contained: classes.buttonContained }}
          href="/"
        >
          Done!
        </Button>
      )
    }

    return (
      <Button
        variant="contained"
        classes={{ contained: classes.buttonContained }}
        onClick={this.handleNext}
      >
        <span className={classes.buttonLabel}>Next</span>
        <img src={SmallArrowRight} alt="→" />
      </Button>
    )
  }

  render() {
    const { classes } = this.props
    const { activeStep } = this.state

    return (
      <div className={classes.root}>
        <div className={classes.tutorialContainer}>
          { tutorialSteps[activeStep] }
        </div>
        <div className={classes.stepperContainer}>
          <div className={classes.stepCount}>
            {activeStep + 1}&nbsp;/&nbsp;{STEPS}
          </div>
          <MobileStepper
            variant="dots"
            steps={STEPS}
            position="static"
            activeStep={activeStep}
            classes={{
              root: classes.mobileStepperRoot,
              dot: classes.dot,
              dotActive: classes.dotActive,
            }}
            nextButton={this.renderNextButton()}
            backButton={(
              <Button
                variant="contained"
                classes={{ contained: `${classes.buttonContained} ${classes.leftIcon}` }}
                onClick={this.handleBack}
                disabled={activeStep === 0}
              >
                <img src={SmallArrowLeft} alt="←" />
                <span className={classes.buttonLabel}>Back</span>
              </Button>
            )}
          />
          <Link to="/" className={classes.link}>
            Skip
          </Link>
        </div>
      </div>
    )
  }
}

export default withStyles(Intro.styles)(Intro)
